export const heroStats = [
  { id: 'online', label: '在线吃瓜群众', value: '12,486', suffix: '人' },
  { id: 'today', label: '今日新增讨论', value: '3,920', suffix: '条' },
  { id: 'opinions', label: '累计观点交锋', value: '48.7', suffix: '万' },
];

export const heroPreviews = [
  {
    id: 'hp-1',
    tag: '影视考古',
    title: '路透碎片拼出完整时间线',
    comments: '1,204',
    image:
      'https://readdy.ai/api/search-image?query=Editorial%20abstract%20collage%20illustration%20with%20warm%20amber%20and%20crimson%20accents%20on%20clean%20off-white%20background%2C%20bold%20geometric%20shapes%20and%20layered%20paper%20texture%2C%20magazine%20cover%20composition%2C%20soft%20natural%20lighting%2C%20no%20text%2C%20high%20detail%2C%20minimal%20art%20direction&width=480&height=360&seq=heliao-hero-01&orientation=landscape',
  },
  {
    id: 'hp-2',
    tag: '消费观察',
    title: '联名海报细节被逐格比对',
    comments: '868',
    image:
      'https://readdy.ai/api/search-image?query=Minimal%20flat%20editorial%20illustration%20of%20overlapping%20poster%20sheets%20and%20magnifying%20glass%20on%20plain%20cream%20background%2C%20warm%20amber%20and%20deep%20crimson%20palette%2C%20clean%20geometric%20lines%2C%20soft%20diffused%20light%2C%20no%20text%2C%20high%20detail&width=480&height=360&seq=heliao-hero-02&orientation=landscape',
  },
  {
    id: 'hp-3',
    tag: '细节研究所',
    title: '背景音被辨认出三条线索',
    comments: '642',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20illustration%20of%20sound%20wave%20lines%20and%20puzzle%20pieces%20on%20soft%20ivory%20background%2C%20warm%20amber%20and%20crimson%20accent%20shapes%2C%20restrained%20geometric%20composition%2C%20even%20studio%20lighting%2C%20no%20text%2C%20high%20detail&width=480&height=360&seq=heliao-hero-03&orientation=landscape',
  },
];

export const trendingList = [
  { id: 't-1', rank: 1, title: '某综艺路透片段流出，网友逐帧比对时间线', tag: '影视考古', heat: '9.8万', change: 'up' },
  { id: 't-2', rank: 2, title: '品牌联名海报细节被扒，评论区吵成两派', tag: '消费观察', heat: '8.6万', change: 'up' },
  { id: 't-3', rank: 3, title: '旧访谈片段被翻出，吃瓜群众重新解读当年耳语', tag: '人物细节', heat: '7.2万', change: 'same' },
  { id: 't-4', rank: 4, title: '直播间口误片段冲上热榜，粉丝与路人观点对撞', tag: '直播回放', heat: '6.5万', change: 'up' },
  { id: 't-5', rank: 5, title: '旅行 vlog 背景音被辨认，细节控列出三条线索', tag: '生活碎片', heat: '5.1万', change: 'down' },
  { id: 't-6', rank: 6, title: '剧集大结局隐藏彩蛋汇总，网友票选最意外一幕', tag: '影视考古', heat: '4.4万', change: 'up' },
  { id: 't-7', rank: 7, title: '音乐节现场机位对比，谁在跟唱引发讨论', tag: '音乐现场', heat: '3.7万', change: 'same' },
  { id: 't-8', rank: 8, title: '手办开箱发现色差，买家与官方各执一词', tag: '消费观察', heat: '2.9万', change: 'down' },
];

export const hotTopics = [
  {
    id: 'h-1',
    tag: '影视考古',
    title: '路透碎片拼出完整时间线，吃瓜群众逐帧复盘',
    summary: '从一张张模糊截图到逐帧比对，评论区把同一天的三个版本现场还原了个遍，细节控贡献了最密集的一份拼图。',
    comments: '1,204',
    views: '8.9万',
    author: '逐帧小组',
    image:
      'https://readdy.ai/api/search-image?query=Editorial%20collage%20illustration%20of%20film%20frames%20and%20timeline%20strips%20on%20warm%20ivory%20background%2C%20amber%20and%20crimson%20accent%20shapes%2C%20clean%20geometric%20layout%2C%20soft%20studio%20light%2C%20no%20text%2C%20high%20detail%2C%20consistent%20minimal%20art%20direction&width=800&height=600&seq=heliao-card-01&orientation=landscape',
  },
  {
    id: 'h-2',
    tag: '消费观察',
    title: '联名款细节争议：设计撞车还是纯属巧合',
    summary: '同一组图形元素出现在两个品牌的新品上，网友把发布时间、草图流传路径排成表格，争论至今没有结论。',
    comments: '962',
    views: '6.3万',
    author: '细节观察员',
    image:
      'https://readdy.ai/api/search-image?query=Minimal%20editorial%20illustration%20of%20two%20overlapping%20product%20packages%20and%20pattern%20swatches%20on%20cream%20background%2C%20warm%20amber%20and%20crimson%20palette%2C%20restrained%20geometric%20lines%2C%20soft%20natural%20light%2C%20no%20text%2C%20high%20detail&width=800&height=600&seq=heliao-card-02&orientation=landscape',
  },
  {
    id: 'h-3',
    tag: '直播回放',
    title: '一句口误引发的千层讨论：是紧张还是别有意味',
    summary: '三秒的口误被反复放慢，逐字听写、语义分析、表情解读同时上线，评论区自动分成了「紧张派」和「有戏派」。',
    comments: '1,530',
    views: '11.2万',
    author: '回放研究所',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20illustration%20of%20microphone%20and%20speech%20bubbles%20on%20warm%20off-white%20background%2C%20amber%20and%20deep%20crimson%20accent%20shapes%2C%20clean%20flat%20geometric%20composition%2C%20even%20lighting%2C%20no%20text%2C%20high%20detail&width=800&height=600&seq=heliao-card-03&orientation=landscape',
  },
  {
    id: 'h-4',
    tag: '综艺现场',
    title: '名场面重温：当年被忽略的那个眼神',
    summary: '老素材重新剪辑后，弹幕里冒出大量新解读。有人说当时就埋了伏笔，也有人说只是网友想多了，两边都在翻原始片段。',
    comments: '734',
    views: '5.1万',
    author: '老片重看',
    image:
      'https://readdy.ai/api/search-image?query=Editorial%20flat%20illustration%20of%20a%20spotlight%20beam%20and%20empty%20stage%20chair%20on%20soft%20ivory%20background%2C%20warm%20amber%20and%20crimson%20accents%2C%20calm%20geometric%20layout%2C%20soft%20shadowless%20lighting%2C%20no%20text%2C%20high%20detail&width=800&height=600&seq=heliao-card-04&orientation=landscape',
  },
  {
    id: 'h-5',
    tag: '影视考古',
    title: '大结局彩蛋考古：道具组到底埋了多少伏笔',
    summary: '从墙上的海报到桌上的杯子，网友把每一帧里出现过的物件都登记在册，最后整理出一份长长的彩蛋清单。',
    comments: '1,088',
    views: '7.7万',
    author: '彩蛋登记处',
    image:
      'https://readdy.ai/api/search-image?query=Minimal%20illustration%20of%20small%20objects%20cataloged%20in%20a%20grid%20on%20cream%20paper%20background%2C%20amber%20and%20crimson%20accent%20marks%2C%20restrained%20line%20style%2C%20flat%20soft%20lighting%2C%20no%20text%2C%20high%20detail&width=800&height=600&seq=heliao-card-05&orientation=landscape',
  },
  {
    id: 'h-6',
    tag: '音乐现场',
    title: '同一首歌，两种现场：机位之争怎么吵起来的',
    summary: '官方机位和观众手机录出来完全是两种气氛，评论区从音准聊到现场收音，最后变成了一个关于「真实现场感」的大讨论。',
    comments: '845',
    views: '4.8万',
    author: '现场组',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20illustration%20of%20stage%20lights%20and%20crowd%20silhouette%20shapes%20on%20warm%20ivory%20background%2C%20amber%20and%20deep%20crimson%20palette%2C%20clean%20flat%20geometric%20composition%2C%20even%20lighting%2C%20no%20text%2C%20high%20detail&width=800&height=600&seq=heliao-card-06&orientation=landscape',
  },
];

export const commentThreads = [
  {
    id: 'c-1',
    side: 'pro',
    user: '拼图爱好者',
    avatar:
      'https://readdy.ai/api/search-image?query=Minimal%20flat%20vector%20avatar%20illustration%20of%20a%20person%20with%20short%20hair%2C%20warm%20amber%20background%2C%20soft%20geometric%20shapes%2C%20clean%20lines%2C%20centered%20composition%2C%20no%20text&width=120&height=120&seq=heliao-ava-01&orientation=squarish',
    text: '时间线其实对得上，只是大家拿的是不同机位的素材。把三份截图叠在一起看，明显是同一段现场，顺序没错。',
    likes: 1284,
  },
  {
    id: 'c-2',
    side: 'con',
    user: '冷静吃瓜',
    avatar:
      'https://readdy.ai/api/search-image?query=Minimal%20flat%20vector%20avatar%20illustration%20of%20a%20person%20with%20glasses%2C%20muted%20teal%20background%2C%20soft%20geometric%20shapes%2C%20clean%20lines%2C%20centered%20composition%2C%20no%20text&width=120&height=120&seq=heliao-ava-02&orientation=squarish',
    text: '别急着下结论。截图可以裁，音轨可以调，我们看到的只是别人想让我们看到的那部分，等原始素材再说。',
    likes: 976,
  },
  {
    id: 'c-3',
    side: 'pro',
    user: '细节控本控',
    avatar:
      'https://readdy.ai/api/search-image?query=Minimal%20flat%20vector%20avatar%20illustration%20of%20a%20person%20with%20a%20cap%2C%20warm%20cream%20background%2C%20soft%20geometric%20shapes%2C%20clean%20lines%2C%20centered%20composition%2C%20no%20text&width=120&height=120&seq=heliao-ava-03&orientation=squarish',
    text: '背景里那个路牌才是关键，查了下当天只有一条街在施工，时间地点一下就锁定了，这波细节我服。',
    likes: 654,
  },
  {
    id: 'c-4',
    side: 'con',
    user: '路人甲上线',
    avatar:
      'https://readdy.ai/api/search-image?query=Minimal%20flat%20vector%20avatar%20illustration%20of%20a%20person%20with%20long%20hair%2C%20soft%20crimson%20background%2C%20geometric%20shapes%2C%20clean%20lines%2C%20centered%20composition%2C%20no%20text&width=120&height=120&seq=heliao-ava-04&orientation=squarish',
    text: '看了一圈，最离谱的是评论区比正片还精彩。大家吵得那么认真，其实谁也没拿到全部证据，图个乐就好。',
    likes: 431,
  },
  {
    id: 'c-5',
    side: 'pro',
    user: '素材库管理员',
    avatar:
      'https://readdy.ai/api/search-image?query=Minimal%20flat%20vector%20avatar%20illustration%20of%20a%20person%20with%20tied%20hair%2C%20warm%20sand%20background%2C%20geometric%20shapes%2C%20clean%20lines%2C%20centered%20composition%2C%20no%20text&width=120&height=120&seq=heliao-ava-05&orientation=squarish',
    text: '我把能找到的公开片段都整理进一个清单了，按时间排好，谁有新素材可以直接补充，别在评论里各说各话。',
    likes: 588,
  },
  {
    id: 'c-6',
    side: 'con',
    user: '反方一号',
    avatar:
      'https://readdy.ai/api/search-image?query=Minimal%20flat%20vector%20avatar%20illustration%20of%20a%20person%20with%20a%20beanie%2C%20muted%20olive%20background%2C%20geometric%20shapes%2C%20clean%20lines%2C%20centered%20composition%2C%20no%20text&width=120&height=120&seq=heliao-ava-06&orientation=squarish',
    text: '过度解读真的没必要，很多巧合就是巧合。把每个眼神都当成线索，最后受伤的往往是被讨论的人。',
    likes: 512,
  },
];

export const communityStats = [
  { id: 's-1', label: '注册吃瓜群众', value: '86.3万' },
  { id: 's-2', label: '日均新增讨论', value: '3,920' },
  { id: 's-3', label: '累计观点评论', value: '487万' },
  { id: 's-4', label: '覆盖讨论版块', value: '10 个' },
];

export const channels = [
  { id: 'ch-1', name: '影视考古', count: '1.2万', icon: 'ri-film-line' },
  { id: 'ch-2', name: '综艺现场', count: '8,640', icon: 'ri-live-line' },
  { id: 'ch-3', name: '人物细节', count: '6,210', icon: 'ri-user-search-line' },
  { id: 'ch-4', name: '消费观察', count: '5,480', icon: 'ri-shopping-bag-3-line' },
  { id: 'ch-5', name: '直播回放', count: '4,930', icon: 'ri-play-circle-line' },
  { id: 'ch-6', name: '音乐现场', count: '3,760', icon: 'ri-music-2-line' },
  { id: 'ch-7', name: '生活碎片', count: '3,120', icon: 'ri-camera-lens-line' },
  { id: 'ch-8', name: '细节研究所', count: '2,870', icon: 'ri-search-eye-line' },
  { id: 'ch-9', name: '观点对撞', count: '2,410', icon: 'ri-chat-3-line' },
  { id: 'ch-10', name: '新瓜速递', count: '2,050', icon: 'ri-alarm-warning-line' },
];

export const guidelines = [
  {
    id: 'g-1',
    icon: 'ri-shield-check-line',
    title: '讨论公开素材',
    desc: '欢迎基于公开片段的细节比对与观点交流，不传播来源不明、无法核对的所谓“独家”。',
  },
  {
    id: 'g-2',
    icon: 'ri-scales-3-line',
    title: '观点可以有立场',
    desc: '正反双方都值得被听见。我们鼓励摆证据、讲逻辑，而不是人身攻击或群体围攻。',
  },
  {
    id: 'g-3',
    icon: 'ri-error-warning-line',
    title: '存疑就标注存疑',
    desc: '尚未证实的说法会被标记为「待确认」，还原真相需要时间，吃瓜也需要耐心。',
  },
  {
    id: 'g-4',
    icon: 'ri-delete-bin-6-line',
    title: '违规内容可举报',
    desc: '涉及隐私泄露、恶意引战的内容会被处理。维护讨论氛围，靠的是每一个参与者。',
  },
];

export const faqs = [
  {
    id: 'f-1',
    q: '黑料社网社区主要聊什么？',
    a: '围绕近期热门的公开话题展开讨论，从影视综艺到消费观察，重点不在结论，而在很多人一起把细节聊清楚的过程。',
  },
  {
    id: 'f-2',
    q: '在社区里可以做什么？',
    a: '可以看热榜、读评论、发表自己的观点。遇到分歧的话题，还能在正反两派里找到和自己视角接近的讨论。',
  },
  {
    id: 'f-3',
    q: '这里的讨论可靠吗？',
    a: '社区对未证实的说法会做出「待确认」标记。我们更希望你把这里当作观点交流场，而不是权威结论来源，重要信息请自行核对。',
  },
  {
    id: 'f-4',
    q: '为什么会有人专门「挖细节」？',
    a: '很多话题的乐趣就在细节里。一帧截图、一段背景音、一个道具，都可能成为新线索，这也是细节研究所最热闹的原因。',
  },
  {
    id: 'f-5',
    q: '如何参与讨论最不容易踩坑？',
    a: '带着证据说话、尊重不同立场、对还没定论的事情保留余地。把话说清楚，比把话说狠更有说服力。',
  },
];

export const marqueeFeed = [
  '某综艺第二期路透更新 3 张新图',
  '联名款草图流传路径整理完成',
  '大结局彩蛋清单已补充至 42 条',
  '音乐节官方机位完整版上线',
  '手办色差对比图新增夜间光源版本',
  '旧访谈完整音轨被重新上传',
  '旅行 vlog 背景音线索更新为 4 条',
  '直播间口误逐字听写稿已校对',
];